import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';

@Injectable({
    providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
    constructor(private _router: Router, private key: StorageService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        const userEnc = localStorage.getItem('u_id');
        const tokenEnc = localStorage.getItem('a_id');

        // Jika TIDAK ada token atau user data → belum login
        if (!userEnc || !tokenEnc) {
            console.log(
                'NoAuthGuard: User not authenticated, allowing access to sign-in'
            );
            return true;
        }
        try {
            const decrypted = this.key.decryptionAES(userEnc);
            const user = JSON.parse(decrypted);

            console.log(
                user
            );

            return this._router.createUrlTree(['/tenant/parking']);
        } catch (e) {
            console.error('NoAuthGuard: Decryption failed, allowing access', e);
            // Jika gagal decrypt, anggap belum login
            return true;
        }
    }
}
